import React, { useState, useRef, useEffect } from "react";
import Tooltip from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import Form from "react-validation/build/form";
import { useForm } from "react-hook-form";
import CheckButton from "react-validation/build/button";
import { ToastContainer, toast } from "react-toastify";
import { confirmAlert } from "react-confirm-alert";
import { API } from "../../../backend.js";
import ButtonLoading from "../../../components/Loder/buttonLoading";
import { getTrans as t } from "../../../Localization/translations";
import { useTickets } from "../../tickiting/components/TicketContext.js";
import { getAssignableUsers } from "../../../services/ticketing/TicketingServices.js";

export default function CreateTicket({ open, onClose, currentUser, inline = false, initialTitle = "", initialDescription = "" }) {
  const { actions, loading, tickets } = useTickets();

  const [title, setTitle] = useState(initialTitle);
  const [description, setDescription] = useState(initialDescription);
  const [priority, setPriority] = useState("medium");
  const [category, setCategory] = useState("");
  const [subCategory, setSubCategory] = useState("");
  const [assignedTo, setAssignedTo] = useState("");
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [users, setUsers] = useState([]);
  const [attachedFile, setAttachedFile] = useState(null);
  const [disable, setDisable] = useState(false);
  const [successful, setSuccessful] = useState(false);

  const [permissions, setPermissions] = useState(localStorage.getItem('permissions'));
  const hasViewAllTicketsPermission = permissions && permissions.split(',').includes('view_all_tickets');

  const checkBtn = useRef();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const form = useRef();
  const fileInputRef = useRef(null);

  const handleCancel = () => {
    onClose && onClose();
  };

  function handleFileChange(e) {
    setAttachedFile(e.target.files[0] || null);
  }

  async function handleCategoryChange(e) {
    const newCategory = e.target.value;
    setCategory(newCategory);
    setSubCategory("");
    console.log("Selected category:", newCategory);
    try {
      if (newCategory) {

        const subs = await actions.getSubcategories(newCategory);
        setSubCategories(subs.data);
      }
      else {
        setSubCategories([]);
      }
    } catch (err) {
      console.error("Failed to load sub-categories:", err);
    }
  }

  function handleSubCategoryChange(e) {
    setSubCategory(e.target.value);
  }

  async function handleAssignedToChange(e) {
    console.log("id user", e.target.value)
    setAssignedTo(e.target.value);
  }


  function handleRemoveFile() {
    setAttachedFile(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  }

  const handleRegister = async () => {
    setSuccessful(false);
    setDisable(true);

    form.current.validateAll();

    const validationErrors = checkBtn.current.context._errors || [];
    console.log("Validation errors:", validationErrors);
    console.log("Form data:", { title, description, priority, category, subCategory, assignedTo });

    if (validationErrors.length === 0) {
      const ticketData = {
        title: title,
        description: description,
        priority: priority,
        category: category,
        sub_category: subCategory || null, // Set to null if hidden or not selected
        assigned_to: assignedTo || null,
        status: assignedTo ? "open" : "new"
      };
      console.log("Sending ticketData:", ticketData);

      try {


        const response = await actions.createTicket(ticketData);
        console.log("Create ticket response:", response);

        if (response) {
          // Now upload attachment if a file is selected
          if (attachedFile) {
            try {
              await actions.uploadAttachment(response.ticket_id, attachedFile);
            } catch (uploadError) {
              console.error("Failed to upload attachment:", uploadError);
              toast.warning("Ticket created, but attachment upload failed: " + (uploadError.message || 'Unknown error'), {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
              });
            }
          }

          setSuccessful(true);
          setDisable(false);

          setTitle("");
          setDescription("");
          setPriority("medium");
          setCategory("");
          setSubCategory("");
          setAssignedTo("");
          setAttachedFile(null);
          if (fileInputRef.current) {
            fileInputRef.current.value = "";
          }

          toast.success("Ticket created successfully", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });

          setTimeout(() => {
            onClose && onClose();
          }, 1500);
        } else {
          console.log("Ticket creation failed, empty response:", response);
          toast.error("Failed to create ticket - no response data", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setDisable(false);
          setSuccessful(false);
        }
      } catch (error) {
        console.error("Ticket creation error:", error);
        const errorMessage = error.response?.data?.message || error.message || "Failed to create ticket";
        toast.error(errorMessage, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        setDisable(false);
        setSuccessful(false);
      }
    } else {
      setDisable(false);
      console.log("Form validation failed:", checkBtn.current.context._errors);
      toast.error("Please fill in all required fields", {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  };

  const userType = localStorage.getItem("customer") || "";

  useEffect(() => {
    async function loadCategories() {
      // ... (category loading logic, no changes here)
      try {
        const cats = await actions.getCategories();
        setCategories(cats.data);
        if (userType === "Customer") {
          const portalCategory = cats.data.find((cat) => cat.name === "Portal");
          if (portalCategory) {
            setCategory(portalCategory.id);
          } else {
            console.error("Portal category not found for Customer user");
            toast.error("Portal category not available", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
          }
        } else {
          const defectCategory = cats.data.find((cat) => cat.name === "Defect");
          if (defectCategory) {
            setCategory(defectCategory.id);
          } else {
            console.error("Defect category not found for non-Customer user");
            toast.error("Defect category not available", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
          }
        }
      } catch (err) {
        console.error("Failed to load categories:", err);
      }
    }
    async function loadUsers() {
      if (userType !== "Customer") {
        try {
          const usersData = await actions.getAssignableUsers();
          const userArray = usersData.data && Array.isArray(usersData.data) ? usersData.data : [];
          const formattedUsers = userArray.map(user => ({
            id: user.user,
            name: user.name,
          }));
          console.log("Assignable users:", formattedUsers);
          setUsers(formattedUsers);
        } catch (err) {
          console.error("Failed to load assignable users:", err);
          toast.error("Failed to load users for assignment", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        }
      }
    }
    loadCategories();
    loadUsers();
  }, []);

  useEffect(() => {
    if (category) {
      (async () => {
        try {
          const subs = await actions.getSubcategories(category);
          setSubCategories(subs.data);
        } catch (err) {
          console.error("Failed to load sub-categories:", err);
        }
      })();
    }
  }, [category]);

  if (!open) return null;

  if (inline) {
    return (
      <div className="container-fluid ">
        <div className="header pb-0 mb-3">
          <h5>{t("Ticket Details")}</h5>
        </div>
        <div className="card" role="document">
          <div className="card-body">
            <div className="row">
              <div className="col-md-12">
                <Form
                  role="form text-left"
                  onSubmit={handleSubmit(handleRegister)}
                  ref={form}
                  action="."
                  method="POST"
                  id="createTicketForm"
                >
                  <>
                    <div className="form-group row ">
                      <div className="col-md-9">
                        <label className="col-form-label required">
                          {t("Subject")} {" "}
                          <Tooltip content={t("Subject_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <input
                          placeholder={t("Enter Subject")}
                          className="form-control"
                          type="text"
                          rows="15"
                          // maxLength="400"
                          value={title}
                          {...register("title", {
                            onChange: (e) => setTitle(e.target.value),
                            required: true,
                          })}
                        />
                        <div className="invalid-feedback">
                          {errors.title?.type === "required" && "Subject is required"}
                        </div>
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-md-5">
                        <label className="col-form-label required">
                          {t("Description")} {" "}
                          <Tooltip content={t("Description_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <textarea
                          className="textareaticket"
                          rows="4"
                          cols="50"
                          placeholder={t("Description")}
                          {...register("description", {
                            onChange: (e) => setDescription(e.target.value),
                            required: true,
                          })}
                        />
                        <div className="invalid-feedback">
                          {errors.description?.type === "required" && "Description is required"}
                        </div>
                      </div>
                      <div className="col-md-5">

                        {/* Row 2: Category & Sub Category */}
                        <div className="row mb-3">
                          <div className="col-md-6">
                            <label className="col-form-label">
                              {t("Category")}{" "}
                              <Tooltip content={t("Category_Tooltip")}>
                                <i className="fa fa-light fa-circle-info"></i>
                              </Tooltip>
                            </label>
                            <select
                              className="form-control"
                              {...register("category")}
                              onChange={handleCategoryChange}
                              value={category}
                            >
                              <option value="">---{t("Select Category")}---</option>
                              {categories.map((cat, i) => (
                                <option key={i} value={cat.id}>
                                  {cat.name}
                                </option>
                              ))}
                            </select>
                          </div>

                          {subCategories.length > 0 && (
                            <div className="col-md-6">
                              <label className="col-form-label">
                                {t("Sub Category")}{" "}
                                <Tooltip content={t("SubCategory_Tooltip")}>
                                  <i className="fa fa-light fa-circle-info"></i>
                                </Tooltip>
                              </label>
                              <select
                                className="form-control"
                                {...register("subCategory")}
                                onChange={handleSubCategoryChange}
                                value={subCategory}
                              >
                                <option value="">{t("Select Sub Category")}</option>
                                {subCategories.map((sub, i) => (
                                  <option key={i} value={sub.id}>
                                    {sub.name}
                                  </option>
                                ))}
                              </select>
                            </div>
                          )}
                        </div>

                        {/* Row 1: Priority */}

                        <div className="row mb-3">
                          <div className="col-md-6">
                            <label className="col-form-label">
                              {t("Priority")}{" "}
                              <Tooltip content={t("Priority_Tooltip")}>
                                <i className="fa fa-light fa-circle-info"></i>
                              </Tooltip>
                            </label>
                            <select
                              className="form-control"
                              name="priority"
                              value={priority}
                              onChange={(e) => setPriority(e.target.value)}
                              style={{ minWidth: 180 }}
                            >
                              <option value="low">Low</option>
                              <option value="medium">Medium</option>
                              <option value="high">High</option>
                              <option value="critical">Critical</option>
                            </select>
                          </div>

                          {/* {userType !== "Customer" && ( */}
                          {hasViewAllTicketsPermission && (
                            <div className="col-md-6">
                              <label className="col-form-label">
                                {t("Assign To")} {" "}
                                <Tooltip content={t("Assign_To_Tooltip")}>
                                  <i className="fa fa-light fa-circle-info"></i>
                                </Tooltip>
                              </label>
                              <select
                                className="form-control"
                                {...register("assignedTo")}
                                onChange={handleAssignedToChange}
                                value={assignedTo}
                              >
                                <option value="">{t("Select User")}</option>
                                {users.map((user, i) => (
                                  <option key={i} value={user.id}>
                                    {user.name}
                                  </option>
                                ))}
                              </select>
                            </div>
                          )}
                        </div>
                      </div>

                    </div>

                    <div className="form-group row">
                      <div className="col-md-6">
                        <label className="col-form-label">
                          {t("Attachment")} {" "}
                          <Tooltip content={t("Attachment_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <input
                          ref={fileInputRef}
                          type="file"
                          onChange={handleFileChange}
                          accept=".pdf,.doc,.docx,.xls,.xlsx,.png,.jpg,.jpeg,.txt"
                          className="form-control"
                          style={{ width: "350px" }}
                        />
                        {attachedFile && (
                          <div className="mt-2 small">
                            {attachedFile.name} ({(attachedFile.size / 1024).toFixed(1)} KB)
                            <button
                              type="button"
                              className="btn btn-link btn-sm text-danger ms-2 p-0"
                              onClick={handleRemoveFile}
                            >
                              ×
                            </button>
                          </div>
                        )}
                      </div>
                      {/* {userType !== "Customer" && (
                        <div className="col-md-6">
                          <label className="col-form-label">
                            {t("Assign To")} {" "}
                            <Tooltip content={t("Assign_To_Tooltip")}>
                              <i className="fa fa-light fa-circle-info"></i>
                            </Tooltip>
                          </label>
                          <select
                            className="form-control"
                            {...register("assignedTo")}
                            onChange={handleAssignedToChange}
                            value={assignedTo}
                          >
                            <option value="">{t("Select User")}</option>
                            {users.map((user, i) => (
                              <option key={i} value={user.id}>
                                {user.name}
                              </option>
                            ))}
                          </select>
                        </div>
                      )} */}

                    </div>

                    <div className="text-left py-3">
                      <button
                        type="button"
                        className="btn btn-secondary btn-md"
                        onClick={handleCancel}
                      >
                        {t("Cancel")}
                      </button>
                      &nbsp;&nbsp;&nbsp;
                      <button
                        type="submit"
                        className="btn btn-primary btn-md"
                        disabled={disable}
                      >
                        {loading ? <ButtonLoading /> : t("Create")}
                      </button>
                    </div>
                  </>
                  <CheckButton style={{ display: "none" }} ref={checkBtn} />
                </Form>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      className="modal fade show"
      tabIndex="-1"
      role="dialog"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: "rgba(0,0,0,0.22)",
        zIndex: 1050,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div className="modal-dialog modal-dialog-centered" style={{ minWidth: 650, maxWidth: 750 }}>
        <div className="modal-content shadow-lg border-0 rounded-4">
          <div className="modal-header border-0 pb-0">
            <h5 className="modal-title w-100 text-center fw-light">Create Ticket</h5>
            <button type="button" className="btn-close" aria-label="Close" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            <form onSubmit={handleSubmit(handleRegister)}>
              <div className="mb-2">
                <label className="form-label fw-semibold">Title</label>
                <input
                  required
                  name="title"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                  className="form-control form-control-lg"
                  placeholder="Enter ticket title"
                />
              </div>
              <div className="mb-2">
                <label className="form-label fw-semibold">Description</label>
                <textarea
                  required
                  name="description"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  className="form-control form-control-lg"
                  placeholder="Describe your issue or request"
                  rows={4}
                />
              </div>
              <div className="mb-2">
                <div className="p-1 bg-light rounded-3 border d-flex flex-wrap gap-3">
                  <div>
                    <label className="form-label mb-1">Priority</label>
                    <select
                      name="priority"
                      value={priority}
                      onChange={(e) => setPriority(e.target.value)}
                      className="form-select form-select-lg"
                      style={{ minWidth: 180 }}
                    >
                      <option value="low">Low</option>
                      <option value="medium">Medium</option>
                      <option value="high">High</option>
                      <option value="critical">Critical</option>
                    </select>
                  </div>
                  <div>
                    <label className="form-label mb-1">Category</label>
                    <select
                      name="category"
                      value={category}
                      onChange={handleCategoryChange}
                      className="form-select form-select-lg"
                      style={{ minWidth: 180 }}
                    >
                      <option value="">-- Select Category --</option>
                      {categories.map((cat) => (
                        <option key={cat.id} value={cat.id}>
                          {cat.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div>
                    <label className="form-label mb-1">Sub Category</label>
                    <select
                      name="subCategory"
                      value={subCategory}
                      onChange={handleSubCategoryChange}
                      className="form-select form-select-lg"
                      style={{ minWidth: 180 }}
                    >
                      <option value="">-- Select Subcategory --</option>
                      {subCategories.map((sub) => (
                        <option key={sub.id} value={sub.id}>
                          {sub.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div>
                    <label className="form-label mb-1">Assign To</label>
                    <select
                      name="assignedTo"
                      value={assignedTo}
                      onChange={handleAssignedToChange}
                      className="form-select form-select-lg"
                      style={{ minWidth: 180 }}
                    >
                      <option value="">-- Select User --</option>
                      {users.map((user) => (
                        <option key={user.id} value={user.id}>
                          {user.name} ({user.email})
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
              <div className="mb-2">
                <label className="form-label fw-semibold">Attachment</label>
                <input
                  ref={fileInputRef}
                  type="file"
                  onChange={handleFileChange}
                  accept=".pdf,.doc,.docx,.xls,.xlsx,.png,.jpg,.jpeg,.txt"
                  className="form-control form-control-lg"
                />
                {attachedFile && (
                  <div className="mt-2 small">
                    {attachedFile.name} ({(attachedFile.size / 1024).toFixed(1)} KB)
                    <button
                      type="button"
                      className="btn btn-link btn-sm text-danger ms-2 p-0"
                      onClick={handleRemoveFile}
                    >
                      ×
                    </button>
                  </div>
                )}
              </div>
              <div className="d-flex justify-content-end gap-2 mt-4">
                <button type="button" className="btn btn-outline-secondary px-4" onClick={onClose} disabled={disable}>
                  Cancel
                </button>
                <button type="submit" className="btn btn-primary px-4" disabled={disable}>
                  {loading ? "Creating..." : "Create"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}